import React, { useContext, useEffect, useState } from "react";
import { Field, Form, Formik } from "formik";
// prettier-ignore
import { Stack, Select, MenuItem, FormControl, InputLabel, Grid, IconButton, InputAdornment, Button, Autocomplete, Box, TextField, FormHelperText } from "@mui/material"
import ClearIcon from "@mui/icons-material/Clear";
import { SubmitButton } from "../common/forms/submitButton";
import { Link } from "react-router-dom";
import DateRangePicker from "../common/forms/dateRangePicker";
import { TargetTabContext } from "../../views/notifications";

export const NotificationsFilters = ({ rowsState, setRowsState }) => {
  const { targetTab, distributors, pointsOfSale } =
    useContext(TargetTabContext);

  const [rangeStartDate, setRangeStartDate] = useState({
    start_date_from: rowsState.start_date_from,
    start_date_to: rowsState.start_date_to,
  });

  const onChangeRangeStartDate = (value) => {
    const newRangeStartDate = {
      start_date_from: value[0]?.getTime(),
      start_date_to: value[1]?.getTime(),
    };
    setRangeStartDate(newRangeStartDate);
  };

  const handleSubmit = async (values) => {
    const { target_pdv, target_distributor } = values;
    const { start_date_from, start_date_to } = rangeStartDate;
    setRowsState((prev) => ({
      ...prev,
      page: 0,
      target_pdv: target_pdv,
      target_distributor: target_distributor,
      start_date_from: start_date_from,
      start_date_to: start_date_to,
      reload: true,
    }));
  };

  return (
    <Grid container>
      <Grid item xs={12} md={5} mb={5}>
        <Formik
          key={targetTab}
          initialValues={rowsState}
          onSubmit={handleSubmit}
        >
          {({
            handleChange,
            isSubmitting,
            values,
            isValid,
            touched,
            errors,
            setFieldValue,
          }) => (
            <Stack
              direction="column"
              component={Form}
              sx={{
                "& .MuiTextField-root,& .MuiFormControl-root": {
                  marginBottom: 2,
                },
              }}
              autoComplete="off"
            >
              {targetTab === "distributor" ? (
                <FormControl sx={{ width: "100%", marginBottom: 1 }}>
                  <InputLabel id="distributor-label">Distribuidor</InputLabel>
                  <Field
                    component={Select}
                    labelId="distributor-label"
                    id="target_distributor"
                    name="target_distributor"
                    label="Distribuidora"
                    value={values.target_distributor}
                    fullWidth
                    onChange={handleChange("target_distributor")}
                    size="small"
                    error={touched.target_distributor && Boolean(errors.target_distributor)}
                    endAdornment={
                      values.target_distributor && (
                        <InputAdornment position="end">
                          <IconButton
                            sx={{ padding: 0.5, mr: 2.3 }}
                            onClick={() => {
                              setFieldValue("target_distributor", "");
                            }}
                          >
                            <ClearIcon sx={{ fontSize: 20 }} />
                          </IconButton>
                        </InputAdornment>
                      )
                    }
                  >
                    {distributors &&
                      distributors.length > 0 &&
                      distributors.map((dist) => {
                        return (
                          <MenuItem key={dist.id} value={dist.id}>
                            {dist.name}
                          </MenuItem>
                        );
                      })}
                  </Field>
                </FormControl>
              ) : (
                <Box sx={{ width: "100%" }}>
                  <Autocomplete
                    id="target_pdv"
                    size="small"
                    loading
                    loadingText={"Cargando..."}
                    options={pointsOfSale}
                    value={
                      pointsOfSale.find((pdv) => pdv.id === values.target_pdv) || null
                    }   
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Punto de venta"
                        error={
                          touched.target_pdv && Boolean(errors.target_pdv)
                        }
                      />
                    )}
                    getOptionLabel={(option) =>
                      option?.name && option?.code_editor
                        ? option.name + " - " + option.code_editor
                        : ""
                    }
                    isOptionEqualToValue={(option, value) =>
                      option.id === value.id
                    }
                    renderOption={(props, option) => {
                      return (
                        <li {...props} key={option.id}>
                          {option?.name && option?.code_editor
                            ? option.name + " - " + option.code_editor
                            : ""}
                        </li>
                      );
                    }}
                    onChange={(event, value) => {
                      setFieldValue("target_pdv", value?.id ? value.id : "");
                    }}
                    sx={{ maxWidth: 489.55 }}
                  ></Autocomplete>
                  {touched.target_pdv && errors.target && (
                    <FormHelperText htmlFor="target_pdv" error>
                      {errors.target_pdv}
                    </FormHelperText>
                  )}
                </Box>
              )}

              <Field
                component={DateRangePicker}
                onChangeRange={onChangeRangeStartDate}
                dateFromFieldName="start_date_from"
                dateToFieldName="start_date_to"
                startText="Fecha inicio"
                middleText="hasta"
                endText="Fecha inicio"
                initialRangeValue={[
                  rowsState.start_date_from ? new Date(rowsState.start_date_from) : null,
                  rowsState.start_date_to ? new Date(rowsState.start_date_to) : null,
                ]}
              />

              <Stack justifyContent={"space-between"} direction="row">
                <Stack spacing={1} direction="row">
                  <SubmitButton
                    text="Buscar"
                    isValid={isValid}
                    isSubmitting={isSubmitting || rowsState.loading}
                  ></SubmitButton>
                  {targetTab === "distributor" && (
                    <Button
                      component={Link}
                      to="/notifications/new"
                      variant="outlined"
                      color="primary"
                    >
                      Nueva
                    </Button>
                  )}
                </Stack>
              </Stack>
            </Stack>
          )}
        </Formik>
      </Grid>
    </Grid>
  );
};
